import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';
import { IId } from 'interfaces/common/common';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deleteOperationWindowRule } from '@api/operationWindowRules';

import { IPartialOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { OPERATION_WINDOW_RULES, OPERATION_WINDOW_RULES_DELETE  } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateOperationWindowRulesDeleteReturned {
	isLoadingDeleteOperationWindowRule: boolean;
	deleteOperationWindowRule: UseMutateFunction<any, any, IId, any>;
}

const useMutateOperationWindowRulesDelete = ({
	onSuccess,
}: IPartialOnSuccess): IUseMutateOperationWindowRulesDeleteReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IId>({
		mutationKey: [OPERATION_WINDOW_RULES_DELETE],
		mutationFn: deleteOperationWindowRule,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.deleteOperationWindowRule,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([OPERATION_WINDOW_RULES]);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		isLoadingDeleteOperationWindowRule: isLoading,
		deleteOperationWindowRule: mutate,
	};
};

export default useMutateOperationWindowRulesDelete;
